/* ZENHERO: kleine UI-Helfer ohne Abhängigkeiten (läuft zusätzlich zu application.js). */
(function () {
    'use strict';

    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    /* ---------- Öffnen/Schließen der Drawer über data-Attribute ----------
       Die Funktionen stammen aus application.js (openMobileMenu, openSearchPopup, openCartDrawer ...). */
    var OPENERS = { menu: 'openMobileMenu', search: 'openSearchPopup', cart: 'openCartDrawer' };
    var CLOSERS = { menu: 'closeMobileMenu', search: 'closeSearchPopup', cart: 'closeCartDrawer' };

    function initOpeners() {
        document.addEventListener('click', function (event) {
            var opener = event.target.closest && event.target.closest('[data-zh-open]');
            if (opener) {
                var fn = window[OPENERS[opener.getAttribute('data-zh-open')]];
                if (typeof fn === 'function') {
                    event.preventDefault();
                    fn();
                }
                return;
            }
            var closer = event.target.closest && event.target.closest('[data-zh-close]');
            if (closer) {
                var cfn = window[CLOSERS[closer.getAttribute('data-zh-close')]];
                if (typeof cfn === 'function') {
                    event.preventDefault();
                    cfn();
                }
            }
        });
    }

    /* ---------- Mega-Menü (Desktop) ----------
       Öffnet per Hover (mit kleiner Verzögerung), per Fokus-Button und Tastatur; Escape schließt. */
    function initMega() {
        var items = document.querySelectorAll('[data-zh-mega]');
        if (!items.length) return;
        var openItem = null;
        var timer = null;

        function setOpen(item, open) {
            var panel = item.querySelector('.zh-mega');
            var toggle = item.querySelector('.zh-nav__toggle');
            if (!panel) return;
            panel.hidden = !open;
            item.classList.toggle('is-open', open);
            if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            openItem = open ? item : (openItem === item ? null : openItem);
        }

        function closeAll(except) {
            items.forEach(function (item) {
                if (item !== except) setOpen(item, false);
            });
        }

        items.forEach(function (item) {
            var toggle = item.querySelector('.zh-nav__toggle');

            item.addEventListener('mouseenter', function (event) {
                if (window.matchMedia('(hover: none)').matches) return;
                window.clearTimeout(timer);
                timer = window.setTimeout(function () {
                    closeAll(item);
                    setOpen(item, true);
                }, 90);
            });

            item.addEventListener('mouseleave', function () {
                window.clearTimeout(timer);
                timer = window.setTimeout(function () { setOpen(item, false); }, 140);
            });

            if (toggle) {
                toggle.addEventListener('click', function () {
                    var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
                    closeAll(item);
                    setOpen(item, willOpen);
                });
            }

            item.addEventListener('focusout', function (event) {
                if (!item.contains(event.relatedTarget)) setOpen(item, false);
            });
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && openItem) {
                var toggle = openItem.querySelector('.zh-nav__toggle');
                setOpen(openItem, false);
                if (toggle) toggle.focus();
            }
        });

        document.addEventListener('click', function (event) {
            if (openItem && !openItem.contains(event.target)) setOpen(openItem, false);
        });
    }

    /* ---------- Mobil-Menü: Akkordeon für Untermenüs ---------- */
    function initMobileAccordion() {
        document.addEventListener('click', function (event) {
            var btn = event.target.closest && event.target.closest('.zh-mm__link--toggle');
            if (!btn) return;
            var sub = document.getElementById(btn.getAttribute('aria-controls'));
            if (!sub) return;
            var open = btn.getAttribute('aria-expanded') !== 'true';
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            sub.hidden = !open;
        });
    }

    /* ---------- Barrierefreiheit: Fokus und Escape für Drawer/Dialoge ----------
       Die Drawer (Mobil-Menü, Warenkorb, Suche, Filter) werden von application.js geöffnet und geschlossen.
       Hier kommen hinzu: Fokus in den Dialog setzen, Tab im Dialog halten, Escape schließt, Fokus zurück zum Auslöser. */
    var DIALOGS = [
        { root: '#mobile-menu', panel: '#mobile-menu-content', close: 'closeMobileMenu' },
        { root: '#cart-drawer', panel: '#cart-drawer .cart-drawer-content', close: 'closeCartDrawer' },
        { root: '#search-popup', panel: '#search-popup .search-popup-content', close: 'closeSearchPopup' },
        { root: '#collection-filter-drawer', panel: '#collection-filter-drawer-content', close: 'closeFilterPopup' }
    ];

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var lastTrigger = null;
    var openDialog = null;

    function isVisible(el) {
        if (!el) return false;
        var rect = el.getBoundingClientRect();
        var style = window.getComputedStyle(el);
        return style.visibility !== 'hidden' && style.display !== 'none' && rect.width > 0 && rect.height > 0;
    }

    function activeDialog() {
        for (var i = 0; i < DIALOGS.length; i++) {
            var rootEl = document.querySelector(DIALOGS[i].root);
            if (rootEl && window.getComputedStyle(rootEl).visibility === 'visible') {
                return DIALOGS[i];
            }
        }
        return null;
    }

    function focusables(panel) {
        return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), isVisible);
    }

    function initDialogs() {
        document.addEventListener('click', function (event) {
            var trigger = event.target.closest && event.target.closest('button, a');
            if (trigger) lastTrigger = trigger;
        }, true);

        var observer = new MutationObserver(function () {
            var dialog = activeDialog();
            if (dialog && dialog !== openDialog) {
                openDialog = dialog;
                window.setTimeout(function () {
                    var panel = document.querySelector(dialog.panel);
                    if (!panel) return;
                    var items = focusables(panel);
                    var target = (dialog.root === '#search-popup' ? panel.querySelector('input[type="search"], input[type="text"]') : null) || items[0];
                    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
                }, 120);
            } else if (!dialog && openDialog) {
                openDialog = null;
                if (lastTrigger && document.contains(lastTrigger) && isVisible(lastTrigger)) {
                    lastTrigger.focus({ preventScroll: true });
                }
            }
        });

        DIALOGS.forEach(function (dialog) {
            var rootEl = document.querySelector(dialog.root);
            if (rootEl) observer.observe(rootEl, { attributes: true, attributeFilter: ['style', 'class'] });
        });

        document.addEventListener('keydown', function (event) {
            var dialog = activeDialog();
            if (!dialog) return;

            if (event.key === 'Escape') {
                var closer = window[dialog.close];
                if (typeof closer === 'function') {
                    closer();
                    event.preventDefault();
                }
                return;
            }

            if (event.key === 'Tab') {
                var panel = document.querySelector(dialog.panel);
                if (!panel) return;
                var items = focusables(panel);
                if (items.length === 0) return;
                var first = items[0];
                var last = items[items.length - 1];
                if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
                    last.focus();
                    event.preventDefault();
                } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
                    first.focus();
                    event.preventDefault();
                }
            }
        });
    }


    /* ---------- Schnellkauf auf der Produktkarte ----------
       Formular [data-zh-quickadd]: POST /cart/add.js, danach Warenkorb-Drawer (oder Warenkorbseite). */
    function initQuickAdd() {
        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form || !form.matches || !form.matches('form[data-zh-quickadd]')) return;
            event.preventDefault();
            var btn = form.querySelector('button[type="submit"]');
            if (form.classList.contains('is-loading')) return;
            form.classList.add('is-loading');
            if (btn) btn.disabled = true;
            var root = typeof window.getShopifyApiRoot === 'function' ? window.getShopifyApiRoot() : '/';
            var payload = {
                id: parseInt(form.querySelector('[name="id"]').value, 10),
                quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1
            };

            function done() {
                form.classList.remove('is-loading');
                if (btn) btn.disabled = false;
            }

            fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
            }).then(function (response) {
                if (!response.ok) throw new Error('add failed');
                return response.json();
            }).then(function () {
                if (form.getAttribute('data-cart-type') === 'page' || typeof window.reloadCart !== 'function') {
                    window.location.href = root + 'cart';
                    return;
                }
                window.reloadCart(function () {
                    done();
                    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
                });
            }).catch(function () {
                done();
                form.submit();
            });
        });
    }

    /* ---------- Collection: Sortierung automatisch absenden, Filter-Drawer ---------- */
    function initCollectionTools() {
        document.addEventListener('change', function (event) {
            var el = event.target;
            if (el && el.matches && el.matches('select[data-zh-autosubmit]') && el.form) el.form.submit();
        });

        var drawer = document.getElementById('zh-filters');
        if (!drawer) return;
        var panel = drawer.querySelector('.zh-drawer__panel');
        var openers = document.querySelectorAll('[data-zh-filters-open]');
        var opener = null;

        function trap(event) {
            if (drawer.hidden) return;
            if (event.key === 'Escape') {
                event.preventDefault();
                close();
                return;
            }
            if (event.key !== 'Tab') return;
            var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), isVisible);
            if (!items.length) return;
            var first = items[0];
            var last = items[items.length - 1];
            if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
                last.focus();
                event.preventDefault();
            } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
                first.focus();
                event.preventDefault();
            }
        }

        function open(trigger) {
            opener = trigger || null;
            drawer.hidden = false;
            document.documentElement.classList.add('zh-no-scroll');
            Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'true'); });
            document.addEventListener('keydown', trap);
            window.setTimeout(function () {
                var target = panel.querySelector('.zh-drawer__close');
                if (target) target.focus({ preventScroll: true });
            }, 60);
        }

        function close() {
            drawer.hidden = true;
            document.documentElement.classList.remove('zh-no-scroll');
            Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'false'); });
            document.removeEventListener('keydown', trap);
            if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
        }

        document.addEventListener('click', function (event) {
            var o = event.target.closest && event.target.closest('[data-zh-filters-open]');
            if (o) { event.preventDefault(); open(o); return; }
            if (event.target.closest && event.target.closest('[data-zh-filters-close]')) { event.preventDefault(); close(); }
        });
    }

    onReady(function () {
        initQuickAdd();
        initCollectionTools();
        initOpeners();
        initMega();
        initMobileAccordion();
        initDialogs();
    });
})();
